import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, apiError } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [motivo] = useState(() => sessionStorage.getItem("atlas_logout_motivo"));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div
        className="hidden lg:flex flex-1 relative items-end p-12 bg-slate-900"
        style={{
          backgroundImage:
            "linear-gradient(to top, rgba(15,23,42,0.92), rgba(15,23,42,0.55)), url(https://images.unsplash.com/photo-1767884162326-54d3e26d444a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="text-white max-w-md">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-9 w-9 rounded bg-sky-500 flex items-center justify-center font-bold text-lg">A</div>
            <span className="text-2xl font-bold tracking-tight">ATLAS</span>
          </div>
          <h1 className="text-3xl font-bold leading-tight mb-3">Gestão operacional de peças auto</h1>
          <p className="text-slate-300 text-sm leading-relaxed">
            Cada pedido registado ao segundo, acessível a toda a equipa. Continue o trabalho de qualquer colega sem perder o histórico.
          </p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <div className="h-8 w-8 rounded bg-sky-500 flex items-center justify-center font-bold text-white">A</div>
            <span className="text-xl font-bold">ATLAS <span className="text-slate-400 font-normal text-sm">by Blaublits</span></span>
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mb-1">Iniciar sessão</h2>
          {motivo && <div className="mb-3 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800" data-testid="login-motivo">{motivo}</div>}
          <p className="text-sm text-slate-500 mb-6">Aceda ao painel operacional Blaublits.</p>

          <div className="space-y-4">
            <div>
              <Label className="text-xs font-semibold text-slate-700">Email</Label>
              <Input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="nome@blaublitz.pt" required data-testid="login-email" className="mt-1 h-10"
              />
            </div>
            <div>
              <Label className="text-xs font-semibold text-slate-700">Palavra-passe</Label>
              <Input
                type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" required data-testid="login-password" className="mt-1 h-10"
              />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full h-10 bg-sky-600 hover:bg-sky-700">
              {loading ? "A entrar…" : "Entrar"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
